import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Airconlocation from "./Airconlocation";
import Clientcategory from "./Clientcategory";
import Principal from "./Principal";

const Clientsetup = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  let navigate = useNavigate();

  const [selected, setSelected] = useState(
    searchParams.get("selected") != null
      ? searchParams.get("selected")
      : "category"
  );
  const [selectedarr, setSelectedarr] = useState([
/*     { label: "Building", value: "location" }, */
    { label: "Location", value: "category" },
    /* { label: "Principal", value: "principal" }, */
  ]);

  useEffect(() => {
    /*  setSelected(searchParams.get("selected")); */
  });
  const selectedfn = (value) => {
    setSelected(value);
    navigate(
      "/clientsetup?selected=" +
        value +
        "&client_id=" +
        searchParams.get("client_id")
    );
  };
  return (
    <div className="container">
      {/* section tab menu */}
      <div className="d-flex flex-wrap mb-3 p-1">
        <a className="btn btn-secondary  me-3">
          <i className="fa fa-cog"></i>
        </a>
        {selectedarr.map((selectedarrs, index) => (
          <button
            onClick={() => selectedfn(selectedarrs.value)}
            key={index}
            className={
              selected === selectedarrs.value
                ? "btn btn-primary me-2"
                : "btn btn-light me-2"
            }
          >
            {selectedarrs.label}
          </button>
        ))}
      </div>
      {/* section tab page */}
      <div>
        {selected === "category" ? (
          <Clientcategory client_id={searchParams.get("client_id")} />
        ) : selected === "location" ? (
          <Airconlocation client_id={searchParams.get("client_id")} />
        ) : selected === "principal" ? (
          <Principal client_id={searchParams.get("client_id")} />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Clientsetup;
